import { ContextKey, Key } from '../storage';

export const modifiers: Record<ContextKey, <T>(val: T) => unknown> = {
    [Key.Client]: (val: unknown) => (val as string)?.toLowerCase(),
};
